<template>
<div>
  <h3 class="mx-2 mb-2">{{title}}</h3>
  <v-card class="pa-2 pt-3">
    <chart-bar :data="dataChart" :options="options" style="height:200px"></chart-bar>
  </v-card>
</div>
</template>

<script>
import colors from 'vuetify/es5/util/colors'
import chartBar from './charts/bar'

export default {
  name: 'ActivityChart',
  props: {
    userId: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    hours: {
      type: Number,
      default: 24
    },
    activityId: {
      type: String,
      required: true
    }
  },
  components: {
    'chart-bar': chartBar
  },
  data() {
    return {
      loading: true,
      rawData: null
    }
  },
  computed: {
    dataItems() {
      return (this.rawData || []).map(r => ({
        t: new Date(`${r['.key']}:00:00Z`),
        y: r['.value']
      }));
    },
    dataChart() {
      return {
        datasets: [{
          data: this.dataItems,
          borderColor: colors.blue.base,
          backgroundColor: colors.blue.base,
        }]
      };
    },
    options() {
      const ctx = this;
      return {
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            type: 'time',
            time: {
              unit: this.xAxisUnit,
              max: this.xAxisMaximum,
              min: this.xAxisMinimum
            },
            maxBarThickness:4
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true,
              callback: function(value) {
                if(value % 1 === 0) {
                  return value;
                }
              }
            },
            scaleLabel: {
              display: true,
              labelString: 'Count'
            }
          }]
        },
        tooltips: {
          intersect: false,
          mode: 'nearest'
        },
        responsive: true,
        maintainAspectRatio: false,
        animation: false
      };
    },
    xAxisUnit() {
      return this.hours > 2 * 24 ? 'day' : 'hour';
    },
    xAxisMaximum() {
      return Math.ceil(new Date().getTime() / 3600000) * 3600000;
    },
    xAxisMinimum() {
      return this.xAxisMaximum - this.hours * 60 * 60 * 1000;
    }
  },
  methods: {
    load() {
      let ref = this.$db.ref('counter').child(this.userId).child(this.activityId).limitToLast(this.hours);
      this.$bindAsArray('rawData', ref, null, function() {
        this.loading = false;
      });
    }
  },
  mounted() {
    this.load();
  }
}
</script>



// WEBPACK FOOTER //
// src/components/activityChart.vue